import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  deleteAssignedKpi,
  deleteDerivativeKpi,
  deleteProjectKpi,
} from '@/features/projects/project-details/api/delete-kpi';

type DeleteKpiProps = Omit<
  UseMutationOptions<
    void,
    unknown,
    | {
        id: number;
        type: 'kpi';
      }
    | {
        id: string;
        type: 'assigned_kpi';
      }
    | {
        id: number;
        type: 'derivative_kpi';
      }
  >,
  'mutationFn'
>;

export const useDeleteKpiMutation = ({ ...props }: DeleteKpiProps = {}) => {
  return useMutation({
    ...props,
    mutationFn: async ({ id, type }) => {
      if (type === 'kpi') {
        await deleteProjectKpi(id);
      } else if (type === 'assigned_kpi') {
        await deleteAssignedKpi(id);
      } else if (type === 'derivative_kpi') {
        await deleteDerivativeKpi(id);
      }
    },
  });
};
